module.exports = __webpack_public_path__ + "static/09-blue-bae51474bcd0287bd0162f3fcc0297a1.jpg";